import { Routes } from '@angular/router';

import { platformAuthGuard } from '@core/platform-auth/platform-auth.guard';
import { adminPropertyFormCanDeactivate } from '@features/admin/admin-properties/admin-property-form.can-deactivate';

export const adminPlatformChildRoutes: Routes = [
  {
    path: 'admin/acesso-negado',
    canActivate: [platformAuthGuard],
    loadComponent: () =>
      import('@features/admin/access-denied/admin-access-denied.page').then((m) => m.AdminAccessDeniedPage),
  },
  {
    path: 'admin/conta/trocar-senha',
    canActivate: [platformAuthGuard],
    loadComponent: () =>
      import('@features/admin/account/change-password/admin-change-password.page').then((m) => m.AdminChangePasswordPage),
  },
  {
    path: 'admin/catalogo/cidades',
    canActivate: [platformAuthGuard],
    data: { platformRoles: ['Admin'] },
    loadComponent: () =>
      import('@features/admin/admin-catalog-locations/admin-catalog-cities-list.page').then((m) => m.AdminCatalogCitiesListPage),
  },
  {
    path: 'admin/catalogo/cidades/:cityId',
    canActivate: [platformAuthGuard],
    data: { platformRoles: ['Admin'] },
    loadComponent: () =>
      import('@features/admin/admin-catalog-locations/admin-catalog-city-detail.page').then((m) => m.AdminCatalogCityDetailPage),
  },
  {
    path: 'admin/imoveis/matriz-tipos',
    canActivate: [platformAuthGuard],
    loadComponent: () =>
      import('@features/admin/property-type-matrix/property-type-matrix.page').then((m) => m.PropertyTypeMatrixPage),
  },
  {
    path: 'admin/imoveis/novo',
    canActivate: [platformAuthGuard],
    canDeactivate: [adminPropertyFormCanDeactivate],
    data: { adminPropertyFormMode: 'create' as const, platformRoles: ['Admin', 'Editor'] as const },
    loadComponent: () => import('../features/admin/admin-properties/admin-property-form.page').then((m) => m.AdminPropertyFormPage),
  },
  {
    path: 'admin/imoveis/:propertyId',
    canActivate: [platformAuthGuard],
    canDeactivate: [adminPropertyFormCanDeactivate],
    data: { adminPropertyFormMode: 'edit' as const, platformRoles: ['Admin', 'Editor'] as const },
    loadComponent: () => import('../features/admin/admin-properties/admin-property-form.page').then((m) => m.AdminPropertyFormPage),
  },
  {
    path: 'admin/imoveis',
    canActivate: [platformAuthGuard],
    data: { platformRoles: ['Admin', 'Editor'] as const },
    loadComponent: () =>
      import('@features/admin/admin-properties/admin-properties-list.page').then((m) => m.AdminPropertiesListPage),
  },
  {
    path: 'admin/usuarios',
    canActivate: [platformAuthGuard],
    data: { platformRoles: ['Admin'] },
    loadComponent: () =>
      import('@features/admin/admin-platform-users/admin-platform-users-list.page').then((m) => m.AdminPlatformUsersListPage),
  },
];
